import React from 'react'
import Moment from 'react-moment'
import NumberFormat  from 'react-number-format'

import { 
  CellCont } from './styled'

export const DataCell = (props) => {

  return (
    <CellCont>
      <div className='title'>{props.title||""}</div>
      {/* <Input value={props.value||"-"} disabled/> */}
      <div className={`value ${props.isAreaText?'areaText':''} ${props.right?'right':''}` }>
        {!props.isDate?
          props.isNumber?
          <NumberFormat value={props.value} displayType={'text'} suffix={` ${props.currency||''}`} decimalScale={2} fixedDecimalScale thousandSeparator={true}/>
          :
          props.value||"-"
          :
          props.value?
            <Moment format="DD MMM YYYY HH:mm">
              {props.value}
            </Moment>
          :'-'
        }
      </div>
    </CellCont >
  )
}